export class AppError {
	constructor(public error?: string) {}
}
